import type { AdminMe } from "@motolynk/api-client";
import { createPanelApp, type NavGroupConfig } from "@motolynk/app-core";

import { modules } from "./modules";

// Sidebar sections most used first, set-up and settings last (Ruff_Plan/admin.html). Empty sections stay hidden.
export const navGroups: NavGroupConfig[] = [
  { id: "main" },
  { id: "business", label: "nav.groups.business" },
  { id: "catalog", label: "nav.groups.catalog" },
  { id: "support", label: "nav.groups.support" },
  { id: "content", label: "nav.groups.content" },
  { id: "reports", label: "nav.groups.reports" },
  { id: "usersSecurity", label: "nav.groups.usersSecurity" },
  { id: "settings", label: "nav.groups.settings" },
];

export const App = createPanelApp({
  panel: "admin",
  product: "ADMIN",
  modules,
  navGroups,
  authCopy: {
    headline: "common:authCopy.admin.headline",
    subheadline: "common:authCopy.admin.subheadline",
    points: [
      "common:authCopy.admin.point1",
      "common:authCopy.admin.point2",
      "common:authCopy.admin.point3",
    ],
  },
  // Staff whose role requires 2FA must set it up before using anything else.
  guard: (me, pathname) => {
    const { mfa } = me as AdminMe;
    return mfa.required && !mfa.enrolled && pathname !== "/account/security"
      ? "/account/security"
      : null;
  },
});
